<template>
  <div>
    <a-modal :title="!id?'新增':isDetail?'详情':'修改'" :visible="visible" @cancel="close" :footer="null" width="900px">
      <a-form :form="form" @submit="handleSubmit">
        <a-form-item label="标题" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input :disabled="isDetail" v-decorator="['title', { rules: [{ required: true, message: '请填写标题' }] }]" />
        </a-form-item>
        <a-form-item label="封面" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-upload :disabled="isDetail" :headers="headers" :action="uploadUrl" list-type="picture-card"
            :file-list="fileList" @preview="handlePreview" @change="handleChange">
            <div v-if="fileList.length < 1">
              <a-icon type="plus" />
              <div class="ant-upload-text">
                封面
              </div>
            </div>
          </a-upload>
          <a-modal :visible="previewVisible" :footer="null" @cancel="handleCancel">
            <img alt="example" style="width: 100%" :src="previewImage" />
          </a-modal>
        </a-form-item>
        <a-form-item label="类型" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-checkbox-group :disabled="isDetail"
            v-decorator="['type', { rules: [{ required: true, message: '请选择类型' }] }]">
            <a-checkbox v-for="item in trainType" :key="item.dictValue" :value="item.dictValue">
              {{ item.dictLabel }}
            </a-checkbox>
          </a-checkbox-group>
        </a-form-item>
        <a-form-item label="关联品牌型号" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-button type="primary" @click="link()">
            关联
          </a-button>
        </a-form-item>
        <a-form-item label="上传附件" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-upload :disabled="isDetail" :action="uploadUrl" :headers="headers" :multiple="false" :file-list="imgList"
            @change="handleChange1" :before-upload="beforeUpload">
            <a-button>
              <a-icon type="upload" /> 上传附件
            </a-button>
          </a-upload>
          <div style="color:red">支持上传视频和文档；支持扩展名：.doc .docx .pdf .xls .xlsx .ppt .pptx .jpg .png .mp4 .avi .wmv</div>
        </a-form-item>
        <a-form-item label="链接地址" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input :disabled="isDetail" v-decorator="['outurl']" />
        </a-form-item>
        <editor :disabled="isDetail" id="tinymce" v-model="content" :init="init"></editor>
        <a-form-item v-if="!isDetail" style="margin-top:30px" :wrapper-col="{ span: 2, offset: 11 }">
          <a-button type="primary" html-type="submit">
            保存
          </a-button>
        </a-form-item>
      </a-form>
    </a-modal>
    <!-- 关联 -->
    <treelink :disabled="isDetail" :modelIds="modelIds" ref="treelink" @ok="linkOk"></treelink>
  </div>
</template>

<script>
import { ACCESS_TOKEN } from '@/store/mutation-types'
import { getfinddictAll } from '@/api/order/orderList'
import treelink from './searchTree.vue'
import { imgUrl } from '@/utils/common'
import { trainEdit, getInfo, trainAdd } from '@/api/trainOverview/trainList'
import tinymce from 'tinymce/tinymce'
import Editor from '@tinymce/tinymce-vue'
import 'tinymce/themes/silver/theme'
import 'tinymce/plugins/image'
import 'tinymce/plugins/media'
import 'tinymce/icons/default'
export default {
  data() {
    return {
      form: this.$form.createForm(this, { name: 'coordinated' }),
      labelCol: {
        xs: { span: 24 },
        sm: { span: 4 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 20 }
      },
      visible: false,
      id: '', // 修改的id
      row: {}, // 修改传过来的
      isDetail: false, // 是否是详情
      // 封面
      uploadUrl: process.env.VUE_APP_API_BASE_URL + '/dfs/upload?type=train',
      headers: {
        token: Vue.ls.get(ACCESS_TOKEN)
      },
      previewVisible: false,
      previewImage: '',
      fileList: [
        // {
        // uid: '-1',
        // name: 'image.png',
        // status: 'done',
        // url: 'https://zos.alipayobjects.com/rmsportal/jkjgkEfvpUPVyRjUImniVslZfWPnJuuZ.png',
        // },
      ],
      trainType: [],  // 类型
      modelIds: [], // 品牌型号
      // 上传附件
      imgList: [
        // {
        //   uid: '-1',
        //   name: 'xxx.png',
        //   status: 'done',
        //   url: 'http://www.baidu.com/xxx.png',
        // },
      ],
      // 富文本
      content: '',
      init: {
        language_url: '/tinymce/langs/zh_CN.js', //语言包的路径
        language: 'zh_CN', //语言
        skin_url: '/tinymce/skins/ui/oxide', //skin路径
        height: 300, //编辑器高度
        branding: false, //是否禁用“Powered by TinyMCE”
        menubar: false, //顶部菜单栏显示,
        automatic_uploads: true,
        paste_data_images: true,
        // plugins: 'advlist link image code textcolor paste textcolor colorpicker',
        file_picker_callback: function (callback, value, meta) {
          console.log('xxxxx: ' + value)
        },
        images_upload_handler: (blobInfo, success, failure) => {
          const img = 'data:image/jpeg;base64,' + blobInfo.base64()
          success(img)
        },
        video_template_callback: function (data) { },
        plugins:
          'advlist autolink lists link image charmap print preview anchor searchreplace visualblocks code fullscreen insertdatetime media table paste code help wordcount',
        toolbar:
          'undo redo | bold italic underline strikethrough | fontsizeselect | forecolor backcolor | alignleft aligncenter alignright alignjustify bullist numlist outdent indent blockquote | image code removeformat'
      },
    }
  },
  components: {
    Editor,
    treelink
  },
  mounted() {
    let dictTypes = ['train_type']
    getfinddictAll({ dictTypes: dictTypes.join() }).then(res => {
      this.trainType = res.train_type
    })
  },
  methods: {
    // 点击新增
    add() {
      console.log(this.modelIds)
      this.visible = true
    },
    // 点击修改
    edit(row, isDetail = false) {
      this.id = row.trainId
      this.row = row
      this.isDetail = isDetail
      this.visible = true
      getInfo(this.id).then(res => {
        if (res.code == 0 && res.data) {
          setTimeout(() => {
            this.form.setFieldsValue({
              title: res.data.title,
              type: res.data.type.split(','),
              outurl: res.data.outurl
            });
          }, 0);
          if (res.data.imgurl) {
            this.fileList = [{
              uid: '-1',
              name: res.data.imgurl.split('/')[res.data.imgurl.split('/').length - 1],
              status: 'done',
              url: imgUrl + res.data.imgurl,
              url1: res.data.imgurl,
            }]
          }
          if (res.data.trainInfos.length) {
            this.imgList = res.data.trainInfos.map(item => {
              return {
                uid: '-1',
                name: item.matterUrl.split('/')[item.matterUrl.split('/').length - 1],
                status: 'done',
                url: imgUrl + item.matterUrl,
                url1: item.matterUrl,
                trainType: item.trainType,
              }
            })
          }

          this.modelIds = res.data.modelIds || []
          this.content = res.data.content || ''
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    // 新增和修改保存
    handleSubmit(e) {
      e.preventDefault();
      this.form.validateFields((err, values) => {
        if (!err) {
          // console.log('Received values of form: ', values);
          // console.log(this.fileList);
          // console.log(this.modelIds);
          // console.log(11, this.imgList);
          values.type = values.type.join(',')
          let arr = this.imgList.filter(item => item.url)
          let trainInfos = arr.length ? arr.map(item => {
            return { matterUrl: item.url1, trainType: item.trainType }
          }) : []
          console.log(22, trainInfos);
          let query = Object.assign(values,
            { modelIds: this.modelIds },
            { imgurl: this.fileList.length ? this.fileList[0].url1 : '' },
            { trainInfos: trainInfos },
            { content: this.content }
          );
          if (this.id) {
            query = Object.assign(query, {
              trainId: this.id,
              releaseStatus: this.row.releaseStatus
            })
            trainEdit(query).then(res => {
              if (res.code === 0) {
                this.$message.success('修改成功!')
                this.close()
                this.$emit('ok')
              } else {
                this.$message.error(res.msg)
              }
            })
          } else {
            trainAdd(query).then(res => {
              if (res.code === 0) {
                this.$message.success('新增成功!')
                this.close()
                this.$emit('ok')
              } else {
                this.$message.error(res.msg)
              }
            })
          }

        }
      });
    },

    close() {
      this.visible = false
      this.form.resetFields()
      this.fileList = []
      this.modelIds = []
      this.imgList = []
      // 复选框选中表单重置报错，加上这个好了
      this.form.setFieldsValue({
        type: []
      });
      this.content = ''
      this.id = ''
      this.row = {}
      this.isDetail = false
    },
    // 封面
    handleCancel() {
      this.previewVisible = false;
    },
    async handlePreview(file) {
      console.log(file)
      this.previewImage = file.url || file.preview;
      this.previewVisible = true;
    },
    handleChange({ fileList }) {
      fileList = fileList.map(file => {
        if (file.response) {
          file.url = imgUrl + file.response.url;
          file.url1 = file.response.url;
        }
        return file;
      });

      this.fileList = fileList;
    },
    // 关联品牌型号
    link() {
      this.$refs.treelink.init()
    },
    linkOk(list) {
      this.modelIds = list
    },
    // 上传附件
    beforeUpload(file) {
      let arr = ["doc", "docx", "pdf", "xls", "xlsx", "ppt", "pptx", "jpg", "png", "mp4", "avi", "wmv"]
      let type = file.name.split('.')[file.name.split('.').length - 1]
      if (!arr.includes(type)) {
        this.$message.error('不支持上传 .' + type + '格式');
      }
      return arr.includes(type);
    },
    handleChange1(info) {
      let fileList = [...info.fileList];
      let arr1 = ['mp4', "avi", "wmv"]
      fileList = fileList.map(file => {
        if (file.response) {
          file.url = imgUrl + file.response.url;
          file.url1 = file.response.url;
          file.trainType = arr1.includes(file.name.split('.')[file.name.split('.').length - 1]) ? 1 : 2
        }
        return file;
      });
      this.imgList = fileList;
    },
  },
}
</script>
<style lang='less' scoped>

</style>